import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  page: {
    height: '100%',
    flexGrow: 1,
  },
  pageCenterAlign: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  coverImg: {
    width: '100%',
    height: `calc(100vh - ${theme.homeStyle.headerHeightDesktop}px)`,
    objectFit: 'cover',
    position: 'sticky',
    top: theme.homeStyle.headerHeightDesktop,
  },
  innerRightSection: {
    padding: theme.spacing(2),
    '& h1': {
      ...theme.homeStyle.title,
      marginBottom: 0,
      marginTop: theme.spacing(2),
      [theme.breakpoints.down('xs')]: {
        marginBottom: 0,
        fontSize: 30,
      }
    },
    '& h2': {
      ...theme.homeStyle.subtitle,
      marginBottom: theme.spacing(6),
      [theme.breakpoints.down('xs')]: {
        fontSize: 18,
      }
    },
  },
  btnsSection: {
    width: '100%',
    maxWidth: 550,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  socialLogin: {
    width: '100%',
  },
  loginBtn: {
    width: '100%',
    height: 50,
    '& img': {
      width: 25,
      height: 25,
      margin: `0 ${theme.spacing(1)}px 0 0`,
    },
  },
  padding1: {
    padding: theme.spacing(1),
  },
  noPaddingX: {
    paddingLeft: '0 !important',
    paddingRight: '0 !important',
  },
  inputsSection: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  forgotPassword: {
    alignSelf: 'flex-end',
  },
  forgotLoginFiller: {
    height: 40,
  },
  loginBtn: {
    height: 50,
  },
  toRegister: {
    textAlign: 'center',
  },
  marginRight1: {
    marginRight: theme.spacing(1),
  },
  confirmEmailCard: {
    ...theme.homeStyle.boxShadow,
    padding: theme.spacing(4),
    margin: theme.spacing(1),
    textAlign: 'center',
  },
  confirmEmailText1: {
    fontSize: 22,
    fontWeight: 400,
    marginTop: 0,
  },
  confirmEmailText2: {
    fontSize: 20,
    fontWeight: 400,
    marginBottom: 0,
  },
  confirmTitle: {
    ...theme.homeStyle.title,
    marginBottom: 0,
    marginTop: theme.spacing(8),
    [theme.breakpoints.down('xs')]: {
      marginBottom: 0,
      fontSize: 40,
    }
  },
  confirmSubtitle: {
    ...theme.homeStyle.subtitle,
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down('xs')]: {
      fontSize: 22,
    }
  },
  colorPrimary: {
    color: theme.palette.primary.main,
  },
  colorSuccess: {
    color: theme.palette.success.main,
  },
  colorError: {
    color: theme.palette.error.main,
  },
  maxWidth500: {
    maxWidth: 500,
  },
  termsPrivacyText: {
    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
    }
  },
  consentGroupCompanyContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 32
  },
  textConsentRemarkStar: {
    margin: 0
  },
  textConsentRemark: {
    margin: 0,
    textIndent: 20
  },
  textConsentRemarkTitle: {
    fontWeight: 'bold'
  },
  textConsentRemarkUnderline: {
    textDecoration: 'underline', 
    margin: 0
  }
}))

export default useStyles